import { useMutation } from '@tanstack/react-query';
import { sendForApproval } from './sendForApproval';
import { AxiosError } from 'axios';
import { globalErrorResponse } from '../../shared/notification/actions';

export const useSendForApproval = (listId: string, onSuccess: () => void) => {
    const mutation = useMutation((email: string) => sendForApproval({ listId, email }), {
        onSuccess,
        onError: (error: AxiosError<{ message?: string }>) => globalErrorResponse(error)
    });

    return {
        ...mutation,
        errorMessage: mutation.error?.response?.data?.message,
        resetError: mutation.reset
    };
};
